import screen from '@ikea-aoa/ikea-shared-styles/lib/variables/Screen.json';

/*
 * "ikea-screen-xx-small": "320px"
 * "ikea-screen-x-small": "480px"
 * "ikea-screen-small": "768px"
 * "ikea-screen-medium": "1024px"
 * "ikea-screen-large": "1440px"
 * "ikea-screen-x-large": "1920px"
 */

export default {
  xxSmall: parseInt(screen['ikea-screen-xx-small'], 10),
  xSmall: parseInt(screen['ikea-screen-x-small'], 10),
  small: parseInt(screen['ikea-screen-small'], 10),
  medium: parseInt(screen['ikea-screen-medium'], 10),
  large: parseInt(screen['ikea-screen-large'], 10),
  xLarge: parseInt(screen['ikea-screen-x-large'], 10),
};
